import angular from 'angular';

export default angular.module('cmsOnLoad', [])
  .directive('cmsOnLoad', function () {
    /** @ngInclude() */
    return {
      restrict: "A",
      scope: {
        callback: "&cmsOnLoad"
      },
      link: function (scope, element) {
        element.on("load", (event) => {
          scope.callback({event: event});
          scope.$apply();
        });
      }
    }
  }).name;


// WEBPACK FOOTER //
// ./src/cmsCore/OnLoadDirective/OnLoadDirective.js